export default "__VITE_ASSET__DKUX6wEV__"